import {Modal} from "../../../../components/modal/modal.jsx";
import Loader from "../../../../components/template/loader.jsx";
import useCachedImage from "../../../../hooks/use-cached-image.js";
import {TransformComponent, TransformWrapper} from "react-zoom-pan-pinch";
import React from "react";

const SentryCloudImageModal = ({showModal, setShowModal, imgUrl}) => {
    const {src, isLoading} = useCachedImage(imgUrl, 'sentry-image-cache',);

    return (
        <>
            <Modal open={showModal} setOpen={setShowModal} title="Passagem">
                <Modal.Body className={"flex justify-center"}>
                    {isLoading && <Loader/>}
                    {!isLoading &&
                        <TransformWrapper>
                            <TransformComponent>
                                <img
                                    className="mx-auto max-h-150 max-w-[95%] rounded-[0.2em]"
                                    src={src}
                                    alt={"Passagem"}
                                />
                            </TransformComponent>
                        </TransformWrapper>
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}

export default SentryCloudImageModal;